module.exports = "/static/assets/253fd3f7e0f97cef20eb5a68f66d5b5c.png";